import { render, staticRenderFns } from "./manage-activities.vue?vue&type=template&id=6af7a405"
import script from "./manage-activities.vue?vue&type=script&lang=js"
export * from "./manage-activities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports